const $ = jQuery;

class GateFormSubmittedEvent {
	constructor (data) {
		this.data = data;
	}

	static getEventName () {
		return "gate-form-submitted";
	}

	trigger () {
		$(document).trigger(GateFormSubmittedEvent.getEventName(), [this.data]);
	}

	static addListener (handle) {
		$(document).on(GateFormSubmittedEvent.getEventName(), (e, data) => {
			handle(data);
		});
	}
}
